import classNames from "classnames";
import styles from "./index.module.less";
/**
 * 输入框包装
 * @param {{
 *    placeholder: String,
 *    isFocus: Boolean,
 *    isFilled: Boolean
 * }} props
 * @returns {Function}
 */
export default function Wrap(props) {
  const {
    placeholder,
    isFocus = false,
    isFilled = false,
    isDisabled = false,
    noWrapper = false,
    className,
  } = props;

  return (
    <div
      className={classNames([
        styles.wrap,
        className,
        noWrapper ? styles.nowrap : null,
        isFocus ? styles.focus : null,
        isFilled ? styles.filled : null,
        isDisabled ? styles.disabled : null,
      ])}
      data-placeholder={placeholder}
    >
      {props.children}
    </div>
  );
}
